import { required, length, email } from "../../utils/validators";
import Auth from "./auth";
import { useState } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import Input from "../../components/form/input/input";
import { signup } from "../../apis/authApi";
function Signup(props) {
  const [state, setState] = useState({
    loginForm: {
      email: {
        value: "",
        isValid: false,
        touched: false,
        message: "please enter a valid email",
        validators: [required, email],
        required: true,
      },
      password: {
        value: "",
        isValid: false,
        touched: false,
        message: "Password must be at least 8 characters",
        required: true,
        validators: [required, length({ min: 8 })],
      },
      confirmPassword: {
        value: "",
        isValid: false,
        touched: false,
        message: "Passwords must match",
        required: true,
      },
      firstname: {
        value: "",
        isValid: false,
        touched: false,
        message: "Firstname must be at least 3 characters",
        required: true,
        validators: [required, length({ min: 3 })],
      },
      lastname: {
        value: "",
        isValid: false,
        touched: false,
        message: "Lastname must be at least 3 characters",
        required: true,
        validators: [required, length({ min: 3 })],
      },
    },
    formIsValid: false,
    logged: false,
    logging: false,
    errorMessage: null,
  });

  const navigate = useNavigate();
  const submitHandler = async (e) => {
    e.preventDefault();
    setState((prevState) => {
      return {
        ...prevState,
        logging: true,
      };
    });
    const email = state.loginForm.email;
    const password = state.loginForm.password;
    const confirmPassword = state.loginForm.confirmPassword;
    const firstname = state.loginForm.firstname;
    const lastname = state.loginForm.lastname;

    // let emailIsValid = true;

    // for (const validator of email.validators) {
    //   emailIsValid = emailIsValid && validator(email.value);
    // }

    // let passwordIsValid = true;

    // for (const validator of password.validators) {
    //   passwordIsValid = passwordIsValid && validator(password.value);
    // }
    // const formIsValid = emailIsValid || passwordIsValid;

    // if (!formIsValid) {
    //   return setState((prevState) => {
    //     return {
    //       ...prevState,
    //       formIsValid: formIsValid,
    //     };
    //   });
    // }

    const authForm = new FormData();
    authForm.append("email", email.value);
    authForm.append("password", password.value);
    authForm.append("confirmPassword", confirmPassword.value);
    authForm.append("firstname", firstname.value);
    authForm.append("lastname", lastname.value);
    authForm.append("createdAt", new Date().toLocaleDateString());

    const { data, error } = await signup(authForm);

    if (error) {
      return setState({
        loginForm: {
          email: {
            value: "",
            isValid: false,
            touched: false,
            message: "please enter a valid email",
            validators: [required, email],
            required: true,
          },
          password: {
            value: "",
            isValid: false,
            touched: false,
            message: "Password must be at least 8 characters",
            required: true,
            validators: [required, length({ min: 8 })],
          },
          confirmPassword: {
            value: "",
            isValid: false,
            touched: false,
            message: "Passwords must match",
            required: true,
          },
          firstname: {
            value: "",
            isValid: false,
            touched: false,
            message: "Firstname must be at least 3 characters",
            required: true,
            validators: [required, length({ min: 3 })],
          },
          lastname: {
            value: "",
            isValid: false,
            touched: false,
            message: "Lastname must be at least 3 characters",
            required: true,
            validators: [required, length({ min: 3 })],
          },
        },
        formIsValid: false,
        logged: false,
        logging: false,
        errorMessage: data.message,
      });
    }
    // navigate("/user/profile?");
    setState((prevState) => {
      return {
        ...prevState,
        logged: true,
        logging: false,
      };
    });
  };

  const inputChangeHandler = (input, value) => {
    setState((prevState) => {
      let isValid = true;
      if (input === "confirmPassword") {
        const isMatched = state.loginForm.password.value === value;
        isValid = isMatched;
      } else {
        for (const validator of prevState.loginForm[input].validators) {
          isValid = isValid && validator(value);
        }
      }
      const updatedForm = {
        ...prevState.loginForm,
        [input]: {
          ...prevState.loginForm[input],
          isValid: isValid,
          value: value,
        },
      };
      let formIsValid = true;
      for (const inputName in updatedForm) {
        console.log(updatedForm);
        formIsValid = formIsValid && updatedForm[inputName].isValid;
      }
      return {
        loginForm: updatedForm,
        formIsValid: formIsValid,
      };
    });
  };

  const inputBlurHandler = (input) => {
    setState((prevState) => {
      return {
        ...prevState,
        loginForm: {
          ...prevState.loginForm,
          [input]: {
            ...prevState.loginForm[input],
            touched: true,
          },
        },
      };
    });
  };
  return (
    <Auth>
      {!state.logged && !state.logging && (
        <form
          onSubmit={submitHandler}
          className="h-full  w-96  p-6 dark:bg-slate-700 bg-gray-400 rounded-md"
        >
          {state.errorMessage && (
            <h1 className="text-center text-red-500">{state.errorMessage}</h1>
          )}
          <div className="flex gap-5 w-auto">
            <Input
              id="firstname"
              label="Firstame"
              type="firstname"
              control="input"
              onChange={inputChangeHandler}
              value={state.loginForm["firstname"].value}
              valid={state.loginForm["firstname"].isValid}
              message={state.loginForm["firstname"].message}
              required={state.loginForm["firstname"].required}
              onBlur={inputBlurHandler}
              touched={state.loginForm["firstname"].touched}
            />

            <Input
              id="lastname"
              label="Lastame"
              type="lastname"
              control="input"
              onChange={inputChangeHandler}
              value={state.loginForm["lastname"].value}
              valid={state.loginForm["lastname"].isValid}
              message={state.loginForm["lastname"].message}
              required={state.loginForm["lastname"].required}
              onBlur={inputBlurHandler}
              touched={state.loginForm["lastname"].touched}
            />
          </div>

          <Input
            id="email"
            label="Email"
            type="email"
            control="input"
            onChange={inputChangeHandler}
            value={state.loginForm["email"].value}
            valid={state.loginForm["email"].isValid}
            message={state.loginForm["email"].message}
            required={state.loginForm["email"].required}
            onBlur={inputBlurHandler}
            touched={state.loginForm["email"].touched}
          />
          <Input
            id="password"
            label="Password"
            type="password"
            control="input"
            onChange={inputChangeHandler}
            value={state.loginForm["password"].value}
            valid={state.loginForm["password"].isValid}
            message={state.loginForm["password"].message}
            required={state.loginForm["password"].required}
            onBlur={inputBlurHandler}
            touched={state.loginForm["password"].touched}
          />
          <Input
            id="confirmPassword"
            label="Confirm password"
            type="password"
            control="input"
            onChange={inputChangeHandler}
            value={state.loginForm["confirmPassword"].value}
            valid={state.loginForm["confirmPassword"].isValid}
            message={state.loginForm["confirmPassword"].message}
            required={state.loginForm["confirmPassword"].required}
            onBlur={inputBlurHandler}
            touched={state.loginForm["confirmPassword"].touched}
          />
          <button
            className="btn float-right mt-6"
            type="submit"
            // loading={props.loading}
            disabled={!state.formIsValid}
          >
            Signup
          </button>
          <div>
            <span>Already have an account? </span>
            <NavLink
              to="/join/signin"
              className="link text-custom-blue font-bold"
            >
              Signin
            </NavLink>
          </div>
        </form>
      )}
      {state.logging && (
        <span className="flex justify-center items-end text-center m-14">
          signing you up <span class="loading loading-dots loading-xs"></span>
        </span>
      )}
      {state.logged && !state.logging && (
        <p className="w-96 text-left dark:bg-slate-800 bg-slate-200 p-5 rounded-md">
          An email has been sent to you to verify your email.
          <br />
          Please check your email inbox or spam
        </p>
      )}
    </Auth>
  );
}

export default Signup;
